import {
  SET_ERROR_MESSAGE,
  SET_MULTILOCATION_ALL_LOCATIONS,
} from 'Constants/redux';
import {
  CLOSE_SUCCESS_SNACKBAR,
  OPEN_SUCCESS_SNACKBAR,
  SET_ALERT,
  SET_CLOSED_VALIDATION_SNACKBAR,
  SET_ERRORS,
  SET_OPEN_VALIDATION_SNACKBAR,
} from 'Constants/tapgoodsConstants';

export function openSuccessSnackBar(message, autoDismiss = 3) {
  return {
    type: OPEN_SUCCESS_SNACKBAR,
    payload: {
      successOpen: true,
      successMessage: message,
      autoDismiss: autoDismiss,
    },
  };
}
export function closeSuccessSnackBar() {
  return {
    type: CLOSE_SUCCESS_SNACKBAR,
    payload: false,
  };
}

export function setOpenValidationSnackBar() {
  return {
    type: SET_OPEN_VALIDATION_SNACKBAR,
    payload: true,
  };
}
export function setClosedValidationSnackBar() {
  return {
    type: SET_CLOSED_VALIDATION_SNACKBAR,
    payload: false,
  };
}

export function setErrors(errors) {
  return {
    type: SET_ERRORS,
    payload: {
      errors: errors,
      errorsOpen: true,
    },
  };
}

export function setAlert(alertMessage) {
  return {
    type: SET_ALERT,
    payload: {
      alertMessage: alertMessage,
      alertOpen: true,
    },
  };
}

export const setErrorMessage = ({ field, text }) => {
  return {
    type: SET_ERROR_MESSAGE,
    payload: {
      field,
      text,
    },
  };
};

export const setMultilocationAllLocations = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_MULTILOCATION_ALL_LOCATIONS,
      payload: value,
    });
  };
};
